import type { Link } from '@content-scheduler/shared/render';
import type { AnchorHTMLAttributes } from 'react';

/**
 * The widget lives in an iframe, so a plain link would load the page inside
 * the widget. Same-tab links target the top window instead.
 */
export function linkProps(link: Link): AnchorHTMLAttributes<HTMLAnchorElement> {
    switch (link.type) {
        case 'url':
            return link.newTab
                ? { href: link.url, target: '_blank', rel: 'noopener noreferrer' }
                : { href: link.url, target: '_top' };
        case 'email':
            return { href: `mailto:${link.email}`, target: '_top' };
        case 'phone':
            return { href: `tel:${link.phone.replace(/[^\d+]/g, '')}`, target: '_top' };
    }
}
